import {
  BaSeButton,
  BaSeCheckbox,
  BaSeInput,
  BaSeParagraph,
  BaSeSelect,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useCityController } from '../../../../hooks/controllers/city-controller';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useUfController } from '../../../../hooks/controllers/uf-controller';
import { useModule } from '../../../../hooks/module/module';
import { EMAIL_REGEX } from '../../../../utils/validators/constants';
import {
  ContentModal,
  ContentTitleModal,
  WrapperFields,
} from './interview-styled';

const INVALID_PHONE = 'Telefone inválido!';
const INVALID_EMAIL = 'E-mail inválido!';
const REQUIRED_FIELD = 'Campo obrigatório não informado!';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const EditCandidate = (props) => {
  console.log(props)
  const [formValidation, setFormValidation] = React.useState(false);
  const [interview, setInterview] = React.useState({});
  const [initialLoader, setInitialLoader] = React.useState(true);
  const { saveInterview, loading } = useInterviewController();
  const { getCitiesByUf, listCities } = useCityController();
  const { getUfs, listUfs } = useUfController();
  const [selected, setSelected] = React.useState({});

  const { modules } = useModule();

  const onValidateEmail = React.useCallback(() => {
    return EMAIL_REGEX.test(interview?.email);
  }, [interview.email]);

  const onValidatePhone = React.useCallback(() => {
    const clearPhone = interview.phone?.replace(/[^\d]/g, '');
    return clearPhone?.length >= 10;
  }, [interview.phone]);

  const onValidate = React.useCallback(() => {
    setFormValidation(true);
    if (
      !interview?.email ||
      !onValidateEmail() ||
      !interview.city ||
      interview.city?.id === 0 ||
      !interview.city?.uf ||
      interview.city?.uf?.id === 0 ||
      !interview?.phone ||
      !onValidatePhone() ||
      interview.candidate?.name?.length === 0 ||
      !interview.candidate?.name?.trim()
    ) {
      return false;
    }
    return true;
  }, [
    interview.candidate,
    interview.city,
    interview.email,
    interview.phone,
    onValidateEmail,
    onValidatePhone,
  ]);

  const save = React.useCallback(() => {
    const validation = onValidate();
    if (validation) {
      saveInterview(interview)
        .then(() => props.closeModal())
        .catch((error) => props.closeModal(error));
    }
  }, [interview, onValidate, props, saveInterview]);

  React.useEffect(() => {
    const module = modules.find((mod) => mod.id === props.interview?.module.id);
    if (module !== undefined) {
      setSelected(module);
    }
    getUfs()
      .then(() => {
        getCitiesByUf(props.interview?.city?.uf).then(() => {
          setInterview({
            ...props?.interview,
            sendEmail: false,
          });
          setInitialLoader(false);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, [getCitiesByUf, getUfs, modules, props]);

  return (
    <>
      <ContentTitleModal bgColor={selected.settingsMap?.primaryColor}>
        <BaSeParagraph
          isBold
          color={
            selected.name === 'Empretec Startup'
              ? BaSeTheme.colors.institucionais.cinzaSebrae10
              : BaSeTheme.colors.defaultColors.white
          }
        >
          {selected.name}
        </BaSeParagraph>
      </ContentTitleModal>
      <ContentModal>
        <BaSeInput
          label="CPF:"
          placeholder="Informe o CPF"
          value={interview.candidate?.cpf}
          mask="cpf"
          inputMode="tel"
          isDisabled={true}
          onChange={(value) => {
            setInterview((actualInterview) => ({
              ...actualInterview,
              candidate: {
                ...actualInterview.candidate,
                cpf: value,
              },
            }));
          }}
        />
        <BaSeInput
          label="Nome completo:"
          placeholder="Informe o nome completo"
          complement={
            formValidation && !interview.candidate.name ? REQUIRED_FIELD : ''
          }
          value={interview.candidate?.name}
          isDisabled={true}
          onChange={(value) => {
            setInterview((actualInterview) => ({
              ...actualInterview,
              candidate: {
                ...actualInterview.candidate,
                name: value,
              },
            }));
          }}
        />
        <BaSeInput
          label="Nome social:"
          placeholder="Informe o nome social (opcional)"
          value={interview.candidate?.socialName}
          isDisabled={false}
          onChange={(value) => {
            setInterview((actualInterview) => ({
              ...actualInterview,
              candidate: {
                ...actualInterview.candidate,
                socialName: value,
              },
            }));
          }}
        />
        <BaSeInput
          label="E-mail:"
          placeholder="Informe o e-mail"
          complement={
            formValidation && !interview.email
              ? REQUIRED_FIELD
              : formValidation && !onValidateEmail()
                ? INVALID_EMAIL
                : ''
          }
          typeInput="email"
          inputMode="email"
          value={interview?.email}
          inputStatus={onValidateEmail() ? 'valid' : 'invalid'}
          onChange={(value) => {
            setInterview((actualInterview) => ({
              ...actualInterview,
              candidate: {
                ...actualInterview.candidate,
              },
              email: value,
            }));
          }}
        />
        <BaSeInput
          label="Telefone:"
          placeholder="Informe o telefone"
          complement={
            formValidation && !interview.phone
              ? REQUIRED_FIELD
              : formValidation && !onValidatePhone()
                ? INVALID_PHONE
                : ''
          }
          typeInput="tel"
          inputMode="tel"
          mask="phoneDDD"
          value={interview?.phone}
          inputStatus={onValidatePhone() ? 'valid' : 'invalid'}
          onChange={(value) => {
            setInterview((actualInterview) => ({
              ...actualInterview,
              candidate: {
                ...actualInterview.candidate,
              },
              phone: value,
            }));
          }}
        />
        <WrapperFields>
          <BaSeSelect
            label="UF do seminário:"
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            complement={
              formValidation &&
                (!interview?.city?.uf || interview?.city?.uf?.id === 0)
                ? REQUIRED_FIELD
                : ''
            }
            selectedValueId={interview?.city?.uf?.id}
            values={listUfs}
            onChange={(value) => {
              if (value.id) {
                setInterview((actualInterview) => ({
                  ...actualInterview,
                  city: {
                    uf: value,
                  },
                }));
              } else {
                setInterview((actualInterview) => ({
                  ...actualInterview,
                  city: {
                    ...actualInterview.city,
                    id: 0,
                  },
                }));
              }
              if (!initialLoader) {
                getCitiesByUf(value);
              }
            }}
          />
          <BaSeSelect
            label="Cidade:"
            color={BaSeTheme.colors.institucionais.cinzaSebrae10}
            searchable
            complement={
              formValidation &&
                (!interview?.city?.id || interview?.city?.id === 0)
                ? REQUIRED_FIELD
                : ''
            }
            selectedValueId={interview?.city?.id}
            values={listCities?.[interview?.city?.uf?.id] || []}
            onChange={(value) => {
              setInterview((actualInterview) => ({
                ...actualInterview,
                city: {
                  ...actualInterview.city,
                  id: value.id,
                },
              }));
            }}
          />
        </WrapperFields>
        {
          selected.id !== 4 && (
            <BaSeCheckbox
              color={BaSeTheme.colors.defaultColors.black}
              label="Enviar e-mail de inscrição"
              value={interview?.sendEmail}
              checked={interview?.sendEmail}
              onChange={(value) => {
                setInterview((actualInterview) => ({
                  ...actualInterview,
                  sendEmail: value,
                }));
              }}
              size="medium"
            />
          )
        }
        <WrapperFields>
          <BaSeButton
            overrideColors={{
              foreground:
                selected.name === 'Empretec Startup'
                  ? BaSeTheme.colors.institucionais.cinzaSebrae10
                  : BaSeTheme.colors.defaultColors.white,
              backgroundColor: selected.settingsMap?.primaryColor,
            }}
            onClick={save}
            type="primary"
            loadingText="Carregando..."
            isLoading={loading}
            value="Salvar e fechar"
          />
        </WrapperFields>
      </ContentModal>
    </>
  );
};
